export function timeCalulate(params) {
  var hh0 = timeformet(Math.floor(params / 3600));
  var mm0 = timeformet(Math.floor((params % 3600) / 60));
  var ss0 = timeformet(Math.floor((params % 3600) % 60));

  return hh0 + " : " + mm0 + " : " + ss0 + "";
}

export function timeformet(params) {
  if (params.toString().length == 0) {
    return "00";
  } else if (params.toString().length == 1) {
    return "0" + params;
  } else {
    return params;
  }
}
